import {View} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setBidAmount, setBidWallet} from '../../store/slices/auction';
import {TextInput} from 'react-native-paper';

export function PayoutDialogBody() {
  const dispatch = useAppDispatch();
  const bid = useAppSelector(state => state.auction.bidAmount);
  const wallet = useAppSelector(state => state.auction.bidWallet);
  const pricePlaceholder = 'Payout Amount in Percent';
  const walletPlaceholder = 'Payout Crypto Wallet';
  return (
    <View style={{width: '100%', height: 'auto'}}>
      <TextInput
        label={pricePlaceholder}
        style={{width: '100%'}}
        keyboardType="number-pad"
        value={bid.toString()}
        onChangeText={value =>
          dispatch(setBidAmount(parseFloat(value)))
        }
        mode={'outlined'}
      />
      <TextInput
        label={walletPlaceholder}
        style={{width: '100%'}}
        keyboardType="number-pad"
        value={wallet}
        onChangeText={value => dispatch(setBidWallet(value))}
        mode={'outlined'}
      />
    </View>
  );
}
